import { useContext, useEffect, useState } from 'react'

import { CurrencyInput } from '@/components/currency-input'
import { toCurrency } from '@/utils/money'
import { Switch, Typography, Input } from '@material-tailwind/react'
import { useSimpleCalculator } from '@/hooks/use-simple-calculator'
import { useFormikContext } from 'formik'
import { NewContractContext } from './context'

export const AssetAmountForm = ({enable}) => {
  const { values, setFieldValue } = useFormikContext()
  const { currentContract } = useContext(NewContractContext)

  const { amounts, handleNetAmount } = useSimpleCalculator({
    defaultTotalAmountCents: currentContract.assetsAmountCents
  })
  const { totalAmountCents, ivaAmountCents, netAmountCents } = amounts

  useEffect(() => {
    if (totalAmountCents < 1) return

    setFieldValue('assets_amount_cents', totalAmountCents)
  }, [totalAmountCents])

  return (
    <>
      <CurrencyInput
        label="Monto acordado neto"
        disabled={!enable}
        defaultValue={netAmountCents}
        onChangeValue={(_, value) => handleNetAmount(value)}
      />

      <Input
        label="IVA"
        disabled={!enable}
        readOnly
        value={toCurrency(ivaAmountCents)}
      />

      <Input
        label="Monto acordado total"
        disabled={!enable}
        readOnly
        name="total_amount_cents"
        value={toCurrency(values.assets_amount_cents)}
      />

    </>
  )
}
